import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-subsection",
  "aria-labelledby": "home-hero-title"
}
const _hoisted_2 = { class: "hero-shell" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  id: "home-hero-title",
  class: "g-rez-votre-commerce"
}, " Gérez votre commerce floral avec simplicité. ", -1)
const _hoisted_5 = { class: "hero-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper" }, " Florisuite est la plateforme tout-en-un conçue pour les fleuristes, offrant des outils puissants pour une gestion optimisée. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "d-marrer-l-essai" }, "Démarrer l'essai gratuit", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "hero-image",
  alt: "Interface Florisuite sur ordinateur portable",
  src: "https://c.animaapp.com/nNxA75tB/img/image.png",
  loading: "eager",
  fetchpriority: "high",
  decoding: "async"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_RouterLink, {
            to: "/inscription",
            class: "button-principal",
            "aria-label": "Démarrer l'essai gratuit"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_8
    ])
  ]))
}